import React from "react";
import "./VacuumF.css";

// Import your 8 images
import Img1 from "../../../Gallery/ServicesImages/VaccumF/img1.jpg";
import Img2 from "../../../Gallery/ServicesImages/VaccumF/img2.jpg";
import Img3 from "../../../Gallery/ServicesImages/VaccumF/img3.jpg";
import Img4 from "../../../Gallery/ServicesImages/VaccumF/img44.jpg";
import Img5 from "../../../Gallery/ServicesImages/VaccumF/img5.jpg";
import Img6 from "../../../Gallery/ServicesImages/VaccumF/img6.jpg";
import Img7 from "../../../Gallery/ServicesImages/VaccumF/img7.jpg";
import Img8 from "../../../Gallery/ServicesImages/VaccumF/img8.jpg";

function VacumF() {
  const products = [
    {
      title: "R Remote operated UV C ROOM sterilizer UV stand UV C sanitizer stand UV room sanitizer",
      img: Img1,
      specs: ["Material: Mild Steel (MS) body with Polycarbonate Cover", "Mobility : Caster Wheels for Easy Movement", "Safety Features: Child Lock, Delayed Start, Motion Sensor Optional"]
    },
    {
      title: "UV C sterilizer box UV Box UV C sanitizer UV sanitizer",
      img: Img2,
      specs: ["Material: Powder Coated Steel", "Power Supply : 220V AC, 50Hz", "Applications : Masks, Mobiles, Keychains, Personal Belongings"]
    },
    {
      title: "UV C ROOM sterilizer UV stand UV C sanitizer stand UV room sanitizer",
      img: Img3,
      specs: ["Material : Stainless Steel", "Safety Features : Motion Sensor Auto Cut-Off", "Coverage Area : Up to 400 sq.ft."]
    },
    {
      title: "MEGA UV C sterilizer box UV Box UV C sanitizer UV sanitizer",
      img: Img4,
      specs: ["Material: Powder Coated MS (Mild Steel)", "Disinfection Cycle Time : 5-10 minutes", "Application : Masks, phones, keys, currency, gadgets"]
    },
    {
      title: "Electronic Equipment Enclosure",
      img: Img5,
      specs: ["Color:Light Grey", "Corrosion Protection:Other, Powder Coated Finish", "Protection Level:IP65"]
    },
    {
      title: "Baby Incubator Enclosure",
      img: Img6,
      specs: ["Design:Transparent enclosure with removable access panels", "Operating Temperature:25C to 37C", "Type:Baby Incubator Enclosure"]
    },
    {
      title: "Machine Guards",
      img: Img7,
      specs: ["Leak Protection:Other, Yes", "Plastic Molding Type:Injection Mould", "Type:Machine Guard"]
    },
    {
      title: "Polycarbonate Machine Guards",
      img: Img8,
      specs: ["Plastic Molding Type:Thermoplastic", "Weight:Depends on dimensions (approx. 3-5 kg/m)", "Heat Resistance:Yes"]
    }
  ];

  return (
    <div className="vf-wrapper">

      <h1 className="vf-title">Vacuum Forming Products</h1>

      <p className="vf-intro">
        Vacuum forming is a versatile manufacturing process used to create
        lightweight, durable plastic components for packaging, industrial,
        medical, and commercial applications.
      </p>

      <div className="vf-grid">
        {products.map((item, index) => (
          <div className="vf-card" key={index}>
            <img src={item.img} alt={item.title} className="vf-img" />
            <h3 className="vf-card-title">{item.title}</h3>

            <ul className="vf-spec-list">
              {item.specs.map((spec, i) => (
                <li key={i}>{spec}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

    </div>
  );
}

export default VacumF;
